import { ref } from 'vue'

export function usePageReloaded() {
    const isPageReloaded = ref(
        window.performance
            .getEntriesByType('navigation')
            .map((nav) => (nav as PerformanceNavigationTiming).type)
            .includes('reload')
    )
    return isPageReloaded
}